import { React, useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/authContext';
import { Link, useNavigate } from 'react-router-dom';

import { IconBuildingEstate, IconHeart, IconHeartFilled, IconArrowUp } from '@tabler/icons-react';
import { Loader, Autocomplete, TextInput, Checkbox, ActionIcon, Select } from '@mantine/core';
import { IconMapPin } from '@tabler/icons-react';
import { format, parseISO } from 'date-fns';

import Box from '../../../composents/Boxes/Standard/Box';
import AppNavbarSyndic from '../../Navbar/NavbarApp';
import RessourceOptions from '../../../components/Constants/RessourcesOptions';

const AllOffersList = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const { getToken } = useContext(AuthContext);
    const [listOffer, setlistOffer] = useState([]);
    const [favOffers, setFavOffers] = useState([]);
    const [search, setSearch] = useState("");
    const [locationFilter, setLocationFilter] = useState("");
    const [contratFilter, setContratFilter] = useState("");
    const [shippingOnly, setShippingOnly] = useState(false);
    const [pendingFavs, setPendingFavs] = useState(() => new Set());
    const [showScrollTop, setShowScrollTop] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }
        getAllOffers();
        getFavOffers();
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 400);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const getAllOffers  = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                "https://boldee-97d8d36af3bd.herokuapp.com/app/offers/alist",
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const list = await response.json();
            setlistOffer(Array.isArray(list) ? list : []);
        } catch (error) {
            return null;
        }
    };

     const getFavOffers = async () => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }
        try {
        const res = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/app/offers/favlist", {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        setFavOffers(Array.isArray(data) ? data.map(id => id.toString()) : []);
        } catch (err) {
            console.error(err);
            setFavOffers([]);
        }
    };

    const toggleFavorite = async (offerId) => {
        const key = offerId.toString();
        if (pendingFavs.has(key)) return;

        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        }

        setPendingFavs(prev => new Set(prev).add(key));
        try {
            const isFav = favOffers.includes(key);
            const url = isFav
                ? `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/delfavlist/${offerId}`
                : `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/addfavlist/${offerId}`;
            const method = isFav ? "DELETE" : "POST";

            const newFavs = isFav
                ? favOffers.filter(id => id.toString() !== key)
                : [...favOffers, key];
            setFavOffers(newFavs);

            const res = await fetch(url, {
                method,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const updatedFavs = await res.json();
            setFavOffers(updatedFavs.map(id => id.toString()));
        } catch (err) {
            console.error(err);
        } finally {
            setPendingFavs(prev => {
                const next = new Set(prev);
                next.delete(key);
                return next;
            });
        }
    };


    const filteredOffers = listOffer.filter((offer) => {
        const matchSearch = search.trim() === "" ||
            offer.title.toLowerCase().includes(search.toLowerCase()) ||
            offer.description?.toLowerCase().includes(search.toLowerCase());
        const matchLocation = locationFilter.trim() === "" ||
            offer.cityOfIntervention?.toLowerCase().includes(locationFilter.toLowerCase()) ||
            offer.postalCode?.toLowerCase().includes(locationFilter.toLowerCase());
        const matchShipping = !shippingOnly || offer.shipping === true;
        const matchContrat = !contratFilter || offer.contrat === contratFilter;
        return matchSearch && matchLocation && matchShipping && matchContrat;
    });
    

    return(
        listOffer || RessourceOptions ? 
            <>
                {isMobile ? (
                    <>
                        <AppNavbarSyndic/>
                        <div className='mrgT5 width95pCenter'>
                            <Autocomplete
                                variant="filled"
                                placeholder="🔍︎ Rechercher une ressource"
                                withClearButton
                                data={
                                    search.trim() === ""
                                    ? []
                                    : listOffer
                                        .filter((offer) =>
                                            offer.title.toLowerCase().includes(search.toLowerCase())
                                        )
                                        .map((offer) => offer.title)
                                }
                                value={search}
                                onChange={setSearch}
                            />
                            <TextInput
                                variant="filled"
                                placeholder="📍 Code postal ou commune"
                                leftSection={<IconMapPin size={16} />}
                                value={locationFilter}
                                onChange={(e) => setLocationFilter(e.currentTarget.value)}
                                mt={8}
                            />
                            <Select
                                variant="filled"
                                placeholder="Type d'offre"
                                data={[
                                    { value: "Vente", label: "Vente" },
                                    { value: "Location", label: "Location" },
                                    { value: "Don", label: "Don" },
                                ]}
                                value={contratFilter}
                                onChange={(v) => setContratFilter(v || "")}
                                clearable
                                mt={8}
                            />
                            <Checkbox
                                label="Livraison disponible"
                                checked={shippingOnly}
                                onChange={(e) => setShippingOnly(e.currentTarget.checked)}
                                mt={8}
                            />
                        </div>

                        <div className="mrgT10 mrgB100">
                            {filteredOffers.length <= 0
                                ?   <div className='vertical txtCenter noMrgTB'>
                                        <p className='dGreyT mrgT30 mrgB5 txt15'>
                                        {search.trim() === ""
                                            ? "Aucune offre est publiée"
                                            : "Aucun résultat trouvé"}
                                        </p>
                                    </div>
                                :   <>
                                        {filteredOffers.map((offer, index) => {
                                        const isFavorite = favOffers.some(id => id.toString() === offer._id.toString());

                                        return (
                                            <div key={index} style={{ position: "relative", margin: '5px 5px' }}>

                                            <div
                                                style={{ position: "absolute", top: 10, right: 10, cursor: "pointer", zIndex: 2 }}
                                                onClick={(e) => { e.preventDefault(); toggleFavorite(offer._id); }}
                                                >
                                                {isFavorite ? (
                                                    <IconHeartFilled size={22} color="gray" />
                                                ) : (
                                                    <IconHeart size={22} color="gray" />
                                                )}
                                            </div>

                                            <Link to={`/app/offers/offer/${offer._id}`} className="aReset bT">
                                                <Box>
                                                <div className="horizontal iCenter">

                                                    <div className='mrgR20 noMrgTB'>
                                                    {offer.pictures.length > 0
                                                        ? <img className="roundImg70" src={offer.pictures[0]} alt='photo_chantier' />
                                                        : offer.author?.company?.logo
                                                        ? <img className="roundImg70" src={offer.author?.company?.logo} alt='logo' />
                                                        : <div className="noAvatarProfileAccount">
                                                            {offer.author?.company
                                                                ? offer.author?.company?.name.split(" ").map(w => w[0]).join("")
                                                                : <IconBuildingEstate height={65} />}
                                                            </div>
                                                    }
                                                    </div>

                                                    <div className="vertical w100">
                                                        <div className="horizontal iCenter" style={{ paddingRight: 32 }}>
                                                            <p className="txt15 mediumplus noMrgTB cap finalDots" style={{ minWidth: 0, flex: 1 }}>{offer.title}</p>
                                                            <span style={{ flexShrink: 0, marginLeft: 6, backgroundColor: "#2e7d32", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4 }}>
                                                                {offer.contrat === "Location" ? "LOC" : offer.contrat === "Don" ? "DON" : "VTE"}
                                                            </span>
                                                        </div>

                                                        <div className="horizontal">
                                                            <p className="txt15 mediumplus noMrgTB cap mrgR3">
                                                            {offer.price?.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                                                            </p>

                                                            {offer.contrat === "Location" && <p className="txt15 mediumplus noMrgTB cap mrgL3">/ jour</p>}
                                                            {offer.contrat === "Don" && <p className="txt15 mediumplus noMrgTB cap mrgL3">- Don</p>}
                                                        </div>

                                                        <p className="noMrg txt13 jumpline finalDotsMed">
                                                            {RessourceOptions.find(option => option.value === offer.ressource)?.group || ""}
                                                        </p>

                                                        <p className="noMrg txt13 finalDotsMed">{offer.cityOfIntervention}</p>

                                                        <p className="txt13 noMrgTB mrgR5">
                                                            {format(parseISO(offer.createdAt), 'dd/MM/yy')}
                                                        </p>
                                                    </div>

                                                </div>
                                                </Box>
                                            </Link>
                                            </div>
                                        );
                                        })}
                                    </>
                            }
                        </div>
                    </>
                ) : (
                    <>
                        <AppNavbarSyndic/>
                        <div
                            className='width50pCenter'
                            style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, marginTop: 40 }}
                            >
                            <Autocomplete
                                variant="filled"
                                size="md"
                                placeholder="🔍︎ Rechercher une ressource"
                                withClearButton
                                data={
                                    search.trim() === ""
                                    ? []
                                    : listOffer
                                        .filter((offer) =>
                                            offer.title.toLowerCase().includes(search.toLowerCase())
                                        )
                                        .map((offer) => offer.title)
                                }
                                value={search}
                                onChange={setSearch}
                                style={{ flex: 1 }}
                            />
                            <TextInput
                                variant="filled"
                                size="md"
                                placeholder="📍 Code postal ou commune"
                                leftSection={<IconMapPin size={16} />}
                                value={locationFilter}
                                onChange={(e) => setLocationFilter(e.currentTarget.value)}
                                style={{ flex: 1 }}
                            />
                            <Select
                                variant="filled"
                                size="md"
                                placeholder="Type d'offre"
                                data={[
                                    { value: "Vente", label: "Vente" },
                                    { value: "Location", label: "Location" },
                                    { value: "Don", label: "Don" },
                                ]}
                                value={contratFilter}
                                onChange={(v) => setContratFilter(v || "")}
                                clearable
                                style={{ width: 160 }}
                            />
                            <Checkbox
                                label="Livraison disponible"
                                size="md"
                                checked={shippingOnly}
                                onChange={(e) => setShippingOnly(e.currentTarget.checked)}
                                styles={{ label: { fontSize: 16 } }}
                                style={{ whiteSpace: "nowrap" }}
                            />
                        </div>

                        <div className="mrgB100 width90pCenter" style={{ marginTop: 40 }}>
                            {filteredOffers.length <= 0
                                ?   <div className='vertical txtCenter noMrgTB'>
                                        <p className='dGreyT mrgT30 mrgB5 txt15'>
                                        {search.trim() === ""
                                            ? "Aucune offre est publiée"
                                            : "Aucun résultat trouvé"}
                                        </p>
                                    </div>
                                :   <div style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(3, 320px)",
                                        gap: 20,
                                        justifyContent: "center"
                                    }}>
                                        {filteredOffers.map((offer, index) => {
                                        const isFavorite = favOffers.some(id => id.toString() === offer._id.toString());

                                        return (
                                            <div key={index} style={{ position: "relative" }}>

                                            <div
                                                style={{ position: "absolute", top: 10, right: 10, cursor: "pointer", zIndex: 2 }}
                                                onClick={(e) => { e.preventDefault(); toggleFavorite(offer._id); }}
                                                >
                                                {isFavorite ? (
                                                    <IconHeartFilled size={22} color="gray" />
                                                ) : (
                                                    <IconHeart size={22} color="gray" />
                                                )}
                                            </div>

                                            <Link to={`/app/offers/offer/${offer._id}`} className="aReset bT">
                                                <Box>
                                                <div className="horizontal iCenter">

                                                    <div className='mrgR20 noMrgTB'>
                                                    {offer.pictures.length > 0
                                                        ? <img className="roundImg70" src={offer.pictures[0]} alt='photo_chantier' />
                                                        : offer.author?.company?.logo
                                                        ? <img className="roundImg70" src={offer.author?.company?.logo} alt='logo' />
                                                        : <div className="noAvatarProfileAccount">
                                                            {offer.author?.company
                                                                ? offer.author?.company?.name.split(" ").map(w => w[0]).join("")
                                                                : <IconBuildingEstate height={65} />}
                                                            </div>
                                                    }
                                                    </div>

                                                    <div className="vertical w100" style={{ minWidth: 0, width: 165 }}>
                                                        <div className="horizontal iCenter" style={{ width: 165, paddingRight: 28 }}>
                                                            <p className="txt15 mediumplus noMrgTB cap finalDots" style={{ minWidth: 0, flex: 1 }}>{offer.title}</p>
                                                            <span style={{ flexShrink: 0, marginLeft: 6, backgroundColor: "#2e7d32", color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4 }}>
                                                                {offer.contrat === "Location" ? "LOC" : offer.contrat === "Don" ? "DON" : "VTE"}
                                                            </span>
                                                        </div>

                                                        <div className="horizontal">
                                                            <p className="txt15 mediumplus noMrgTB cap mrgR3">
                                                            {offer.price?.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                                                            </p>

                                                            {offer.contrat === "Location" && <p className="txt15 mediumplus noMrgTB cap mrgL3">/ jour</p>}
                                                            {offer.contrat === "Don" && <p className="txt15 mediumplus noMrgTB cap mrgL3">- Don</p>}
                                                        </div>

                                                        <p className="noMrg txt13 jumpline finalDotsMed" style={{ width: 165 }}>
                                                            {RessourceOptions.find(option => option.value === offer.ressource)?.group || ""}
                                                        </p>

                                                        <p className="noMrg txt13 finalDotsMed" style={{ width: 165 }}>{offer.cityOfIntervention}</p>

                                                        <p className="txt13 noMrgTB mrgR5">
                                                            {format(parseISO(offer.createdAt), 'dd/MM/yy')}
                                                        </p>
                                                    </div>

                                                </div>
                                                </Box>
                                            </Link>
                                            </div>
                                        );
                                        })}
                                    </div>
                            }
                        </div>

                        {showScrollTop && (
                            <ActionIcon
                                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                                radius="xl"
                                size={50}
                                color="dark"
                                variant="filled"
                                style={{ position: "fixed", bottom: 30, right: 30, zIndex: 100 }}
                                >
                                <IconArrowUp size={24} />
                            </ActionIcon>
                        )}
                    </>
                )}
            </>
        :
         <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className='mrgT5'>Chargement ...</div>
        </div>
    )
}

export default AllOffersList;

